import fontFamilyTextPlugin from './fontFamilyTextPlugin';
export default fontFamilyTextPlugin;